'use client'

import React from 'react'

export interface SolutionCardProps {
  title: string
  description: string
  /** 카드 아이콘 영역 안에 렌더할 React 노드 (사용하는 쪽에서 아이콘 컴포넌트/엘리먼트 전달) */
  icon: React.ReactNode
  styles: Record<string, string>
}

export function SolutionCard({ title, description, icon, styles }: SolutionCardProps) {
  return (
    <div className={styles.solutionCard}>
      <div className={styles.solutionCardIcon}>
      {icon}
      </div>
      <div className={styles.solutionCardContent}>
        <div className={styles.solutionCardTitle}>{title}</div>
        <div
          className={styles.solutionCardDescription}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  )
}
